export default __webpack_public_path__ + "static/media/1922.15cecab0.png";